import React from 'react';

import { __t, applyTranslations } from 'utils/language';

import StatusLabel from 'components/status-label/StatusLabel';

import './campaign-payments-status.scss';

applyTranslations(require('./campaign-payments-status.i18n.json'));

type Props = {
  profileType: 'brand' | 'influencer',
  status: 'pending' | 'invoiced'
};

const MSG_KEY = 'campaign_payments_status';

const CampaignPaymentsStatus = ({ status, profileType }: Props) => {
  const statusType = status === 'pending' ? 'warning' : 'success';

  return (
    <section className="campaign-payments-status">
      <StatusLabel
        type={statusType}
        label={__t(`${MSG_KEY}.labels.${profileType}_${status}`)}
        size="small"
      />
    </section>
  );
};

export default CampaignPaymentsStatus;
